import * as React from "react"

const WalletConnect = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M3.87 5.08a5.94 5.94 0 0 1 8.26 0l.28.27a.3.3 0 0 1 0 .41l-.94.92a.15.15 0 0 1-.2 0l-.39-.37a4.14 4.14 0 0 0-5.76 0l-.4.4a.15.15 0 0 1-.22 0l-.94-.92a.28.28 0 0 1 0-.41l.3-.3Zm10.2 1.9.85.83c.1.1.1.29 0 .4l-3.78 3.7a.3.3 0 0 1-.41 0L8.05 9.27a.07.07 0 0 0-.1 0L5.27 11.9a.3.3 0 0 1-.41 0L1.09 8.21a.28.28 0 0 1 0-.4l.83-.82a.3.3 0 0 1 .41 0L5.01 9.6c.03.02.08.02.1 0L7.8 6.99a.3.3 0 0 1 .42 0l2.67 2.62c.03.03.08.03.1 0l2.69-2.62a.3.3 0 0 1 .4 0Z" />
  </svg>
)

export default WalletConnect
